import { Skeleton, styled } from "@mui/material";

const ChipSkeleton = () => {
  return (
    <StyledChipSkeleton className="category_box chip">
      <Skeleton variant="text" height={12} width={96} />
    </StyledChipSkeleton>
  );
};

const StyledChipSkeleton = styled('button')({
});

export default ChipSkeleton;
